import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
export default function CardElement(
  { title, img, href }: { title: string; img: string; href: string }) {

  return (
    <Card sx={{ width: 480 }}>
      <CardActionArea href={href}>
        <CardMedia
          component="img"
          height="320"
          image={`/media/index/${img}.jpg`}
          alt="green iguana"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {title}
          </Typography>
        </CardContent>
      </CardActionArea>
      </Card>
  );
}
